module.exports = __webpack_public_path__ + "media/images/home/paper_icon-333b19371302d28d2aec84edf4a39f21.svg";